import{getPlatform as r}from"@tencentcloud/universal-api";var e="pc"===r(),o="h5"===r();export{o as isH5,e as isPC};
